import { render, staticRenderFns } from "./subestacao.vue?vue&type=template&id=9872e59c"
import script from "./subestacao.vue?vue&type=script&lang=js"
export * from "./subestacao.vue?vue&type=script&lang=js"
import style0 from "./subestacao.vue?vue&type=style&index=0&id=9872e59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports